import { NotificationConfiguration } from '../notification.templates';

export const CR_PUBLISH_CIRCULAR_RESOLUTION_TEMPLATE: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> asks you to vote until <b>{dueDate}</b>.`,
  email: {
    ctaKey: 'vote_now',
  },
};
